import { HeaderLayoutConfig } from "@hoa00/i24-core-ui";

export const salesLayoutConfig: HeaderLayoutConfig = {
  appName: "Core HRM: Sales",
  backgroundColor: "#1677ff", //"#02b476"
  // color: "gray",
};
